import type { RouteConfigs } from "@klondpay/layout";

export const routerArrays: Array<RouteConfigs> = [
  {
    path: "/welcome",
    parentPath: "/",
    meta: {
      title: "menus.hshome",
      icon: "home-filled"
    }
  }
];

// 从共享包导出类型，方便项目使用
export type {
  routeMetaType,
  RouteConfigs,
  multiTagsType,
  tagsViewsType,
  setType,
  childrenType,
  themeColorsType,
  scrollbarDomType
} from "@klondpay/layout";
